import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { GtwSnackbarService } from '../../../shared/_services/gtw-snackbar.service';
import { map, throwError } from 'rxjs';


@Injectable({
	providedIn: 'root'
})
export class MefEfileService {
	url = {

		deleteMEf: '/saveJsonObject?action_code=g46j6i',
		syncJob: '/saveJsonObject?action_code=p2u3sn',
		insertFilingData: '/saveJsonObject?action_code=4erq72'
	}
	durationInSeconds = 5;
	constructor(private httpClient: HttpClient, private http: HttpClient, private _snackBar: MatSnackBar, private gtwSnackbar: GtwSnackbarService) { }



	deleteMEf(baseURL: string, params: any, jsonSettings: any, jsonData: any, scenarioCode: string, isIssueKeyEnabled: string, issueKey: number) {
		let clientKey = sessionStorage.getItem('client_key') || '';

		let headers = new HttpHeaders();
		headers.append('Content-Type', 'application/x-www-form-urlencoded');

		headers.append('withCredentials', 'true');

		let body = new FormData();
		body.append('clob_settings', JSON.stringify([jsonSettings]));
		body.append('clob_data', JSON.stringify(jsonData));
		body.append('tax_year', String(params.tax_year ?? ''));
		body.append('scenario', String(params.scenario ?? ''));
		body.append('jcd_key', String(params.jcd_key ?? ''));
		body.append('le_type', String(params.le_type ?? ''));
		body.append('process_name', 'delete-mef-data');
		body.append('is_issue_key_enabled', isIssueKeyEnabled);
		body.append('issue_key', issueKey.toString());
		body.append('scenarioCode', scenarioCode);

		const url = `${baseURL}${this.url.deleteMEf}`;


		return this.httpClient.post(url, body, { headers }).pipe(
			map((res: any) => {
				if (res.callSuccess == "1") {
					if (res.errorMessage != "null") {
						this.openSnackBar(res.errorMessage, 'gtw-snackbar--red');
					}
					this.openSnackBar("Success!", 'gtw-snackbar--green');
					return res;
				} else {
					this.openSnackBar(res.errorMessage, 'gtw-snackbar--red');
				}
				throwError(new Error('oops!'));
				return "error";
				return null;
			}
			));
	}

	sync(baseURL: string, params: any, scenarioCode: string, isIssueKeyEnabled: string, issueKey: number,) {
		if (params.filing_grp_key == null) {
			this.openSnackBar("Cannot sync for this entity!", 'gtw-snackbar--red');
			return throwError("error");
		}

		let clientKey = sessionStorage.getItem('client_key') || '';

		let headers = new HttpHeaders();
		headers.append('Content-Type', 'application/x-www-form-urlencoded');

		headers.append('withCredentials', 'true');

		let body = new FormData();
		body.append('tax_year', String(params.tax_year ?? ''));
		body.append('scenario', String(params.scenario ?? ''));
		body.append('jcd_key', String(params.jcd_key ?? ''));
		body.append('le_key', String(params.le_key ?? ''));
		body.append('filing_grp_key', params.filing_grp_key ? String(params.filing_grp_key) : '');
		body.append('consol_grp_key', params.consol_grp_key ? String(params.consol_grp_key) : '');
		body.append('mef_grp_key', params.mef_grp_key ? String(params.mef_grp_key) : '');
		body.append('grp_type', params.grp_type ? String(params.grp_type) : '');
		body.append('process_name', String(params.process_name ?? ''));
		body.append('form_filer_ind', String(params.form_filer_ind ?? ''));
		body.append('is_issue_key_enabled', isIssueKeyEnabled);
		body.append('issue_key', issueKey.toString());
		body.append('scenarioCode', scenarioCode);

		const url = `${baseURL}${this.url.syncJob}`;


		return this.httpClient.post(url, body, { headers }).pipe(
			map((res: any) => {
				if (res.callSuccess == "1") {
					if (res.errorMessage != "null") {
						this.openSnackBar(res.errorMessage, 'gtw-snackbar--red');
					}
					this.openSnackBar("Success!", 'gtw-snackbar--green');
					return res;
				} else {
					this.openSnackBar(res.errorMessage, 'gtw-snackbar--red');
					return "error";
				}
				throwError(new Error('oops!'));
				return null;
			}
			));


	}

	saveFilingData(baseURL: string, params: any, jsonSettings: any, jsonData: any, scenarioCode: string, isIssueKeyEnabled: string, issueKey: number,) {
		let clientKey = sessionStorage.getItem('client_key') || '';

		let headers = new HttpHeaders();
		headers.append('Content-Type', 'application/x-www-form-urlencoded');

		headers.append('withCredentials', 'true');

		let body = new FormData();
		body.append('clob_settings', JSON.stringify([jsonSettings]));
		body.append('clob_data', JSON.stringify(jsonData));
		body.append('tax_year', String(params.tax_year ?? ''));
		body.append('scenario', String(params.scenario ?? ''));
		body.append('jcd_key', String(params.jcd_key ?? ''));
		body.append('type', String(params.type ?? ''));
		body.append('process_name', 'insert-filing-data');
		body.append('is_issue_key_enabled', isIssueKeyEnabled);
		body.append('issue_key', issueKey.toString());
		body.append('scenarioCode', scenarioCode);

		const url = `${baseURL}${this.url.insertFilingData}`;


		return this.httpClient.post(url, body, { headers }).pipe(
			map((res: any) => {
				if (res.callSuccess == "1") {
					if (res.errorMessage != "null") {
						this.openSnackBar(res.errorMessage, 'gtw-snackbar--red');
					}
					this.openSnackBar("Success!", 'gtw-snackbar--green');
					return res;
				} else {
					this.openSnackBar(res.errorMessage, 'gtw-snackbar--red');
					return "error";
				}
				throwError(new Error('oops!'));
				return null;
			}
			));
	}


	openSnackBar(message: string, panelClass: string = '') {
	  this.gtwSnackbar.openSnackBar(message, (panelClass || '') as any, true, this.durationInSeconds);
	}
}
